<div class="custom__progress-container">
  <div class="progress-text">{{ formattedValues }}</div>
  <div class="progress-bar-container" [style.background-color]="backgroundColor">
    <div class="progress-bar" [style.width]="progressWidth" [style.background-color]="progressColor"></div>
  </div>
</div>